import React, { Component } from 'react';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import RadioGroup from '../RadioGroup';
import { withTranslation, Trans } from 'react-i18next';
import { aftcabinImageOptions } from './views/aftcabin'

class X56AftCabin extends Component {
    constructor(props) {
        super(props);
        this.handleBedChange = this.handleBedChange.bind(this);
        this.handleFurnitureChange = this.handleFurnitureChange.bind(this);
        this.handleFabricChange = this.handleFabricChange.bind(this);

        this.bedOptions = [
            { value: 0, label: 'Double Berth' },
            { value: 1, label: 'Split berth' }
        ];

        this.furnitureOptions = [
            { value: 0, label: 'None' },
            { value: 1, label: 'Upper shelves' },
            { value: 2, label: 'Freeboard hung sea berths' },
            { value: 3, label: 'Upper cabinets' }
        ];
    }

    handleBedChange(newValue) {
        let configuration = this.props.configuration;
        let currentIndex = configuration.AftCabinLayout.value - 1;

        configuration.AftCabinLayout = this.props.aftCabinOptions[(newValue.value * 4) + (currentIndex % 4)];

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFurnitureChange(newValue) {
        let configuration = this.props.configuration;
        let currentIndex = configuration.AftCabinLayout.value - 1;

        configuration.AftCabinLayout = this.props.aftCabinOptions[(newValue.value) + (currentIndex - (currentIndex % 4))];

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleFabricChange(newValue) {
        let configuration = this.props.configuration;
        configuration.FabricAftCabin = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = aftcabinImageOptions;

        let image = <ConfiguratorImage boat="X5_6" configuration={this.props.configuration} options={imageOptions} />;

        let selectedBed = this.bedOptions[Math.floor((this.props.configuration.AftCabinLayout.value - 1) / 4)];
        let selectedFurniture = this.furnitureOptions[(this.props.configuration.AftCabinLayout.value - 1) % 4];

        return (
            <ConfiguratorSection image={image}>
                <ConfiguratorOption>
                    <h1><Trans defaults='Aft Cabins' /></h1>
                    <h2><Trans defaults='Furniture' /></h2>

                    <p><Trans defaults='Split berth in the X5<sup>6</sup> in both aft cabins is standard, two split berths than can be converted into a double berth by adding the `fill in cushion` leaving an unused and easy accessible storage below the berth.' /></p>
                    <p><Trans defaults='Additionally, upper shelves are standard.' /></p>
                    <p><Trans defaults='Upper cabinets and freeboard hung sea berths are optional.' /></p>


                    <RadioGroup options={this.furnitureOptions} value={selectedFurniture} onChange={this.handleFurnitureChange} />

                    <RadioGroup options={this.bedOptions} value={selectedBed} onChange={this.handleBedChange} />
                    
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(X56AftCabin);


// WEBPACK FOOTER //
// ./src/X56/X56AftCabin.js